export default __webpack_public_path__ + "static/androidQrcode-1c64f9784b62206b4e1fdf75e63e08eb.jpeg";